import { SHIPPING_TYPE } from '@constants/index'
import { useTranslation } from 'react-i18next'

interface ShippingMessage {
  data: {
    option_prices: {
      [key: string]: {
        shipping_type: string
      }
    }
    shipping_type: string
  }
  selectedSku: number
}

const ShippingMessage = ({ data, selectedSku }: ShippingMessage) => {
  const { t: translate } = useTranslation('common')

  const selectedOptionShippingType =
    data?.option_prices?.[selectedSku?.toString()]?.shipping_type
  const shippingType = selectedOptionShippingType || data?.shipping_type
  const normalizedShippingType = shippingType === 'false' ? false : shippingType

  return (
    <div>
      {!normalizedShippingType ||
      normalizedShippingType === SHIPPING_TYPE.INCLUDED_IN_THRESHOLD ? (
        <span className="pl-1 font-bold text-sm text-brand-green">
          & {translate('shipping.freeShipping')}
          <span className="font-normal text-black">
            {' '}
            {translate('shipping.onOrdersOver', { amount: 750 })}
          </span>
        </span>
      ) : normalizedShippingType === SHIPPING_TYPE.NEVER_SHIPS_FREE ? (
        <p className="text-brand mt-2 font-medium md:text-[15px]">
          {translate('shipping.neverShipsFree')}
        </p>
      ) : null}
    </div>
  )
}

export default ShippingMessage
